<template>

    <div class="row">
        <div class="col-12">
            <div class="form-row">
                <div class="form-group col-md-12">
                    <label>Archivo</label>
                    <b-form-file id="file-default" v-model="archivos" multiple></b-form-file>
                </div>
            </div>
            <div class="form-row">
                <!--<div class="form-group col-md-12">
                    <label>Acceso</label>
                    <b-form-checkbox
                            id="checkbox-1"
                            v-model="model.publico"
                            name="checkbox-1"
                            value="1"
                            unchecked-value="0"
                    >
                      Publico
                    </b-form-checkbox>
                </div>-->
            </div>
            <div class="form-row">
                <div class="form-group col-md-12">
                    <b-progress :value="uploadPercentage" :max="100" show-progress animated></b-progress>
                </div>
            </div>

            <b-row align-h="end">
                <button class="btn btn-info m-1" v-on:click="upload()">OK</button>
                <button class="btn btn-warning m-1" v-on:click="salir">Salir</button>
            </b-row>
        </div>
    </div>

</template>

<script>
    export default {
        name: "subir-archivos",
        data(){
            return {
                archivos:null,
                model:{},
                uploadPercentage:0
            }
        },
        props: {
            url: String
        },
        methods :{
            salir(){

            },
            upload(){
                if(this.archivos==null){
                    this.$swal('Cuidado','Seleccione el archivo','warning');
                    return;
                }
                this.isLoading=true;
                this.model_save = Object.assign({}, this.model);
                let formData = new FormData();
                Object.keys(this.model_save).forEach(key => {
                    const data = this.model_save[key];
                    formData.append(key,data);
                });
                //formData.append('file',this.archivo);
                this.archivos.forEach((item)=>{
                    formData.append('file[]',item);
                });
                this.axios.post( process.env.VUE_APP_BACKEND+'/api/archivos' ,
                    formData,
                    {
                        onUploadProgress: function( progressEvent ){
                            this.uploadPercentage = parseInt(
                                Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
                            console.log(this.uploadPercentage);
                        }.bind(this)
                    }
                )
                .then((response)=>{
                    if(response.data.success){
                        this.archivos=response.data.archivos;
                        this.$emit("upload-complete", this.archivos);
                    }
                    else
                    {
                        this.$swal('Cuidado','No se Subio.','warning');
                    }
                })
                .finally(()=>{
                    this.isLoading=false;
                })
                .catch((error) =>{
                    this.$swal('Cuidado',error.response.data.mensaje,'warning');
                    this.isLoading=false;
                });
            },
        }
    }
</script>

<style scoped>

</style>